<app-modal-title i18n>My profile</app-modal-title>
<app-modal-body>
    <div class="ot-mr-1 ot-ml-1 ot-mb-1">
        <app-user-form [type]="formType" [currentTab]="UserFormTab.GENERAL" [currentUserAuthInfo]="currentUserAuthInfo" (formEvent)="updateUserForm($event)" (errorEvent)="close($event)"></app-user-form>
    </div>
</app-modal-body>
<app-modal-footer>
    <button otsc-button color="primary" [disabled]="profileForm.invalid || profileForm.controls.dataCtrl.invalid" (click)="save()" i18n>
        Save
    </button>
    <button otsc-button color="secondary" (click)="close()" i18n>
        Cancel
    </button>
</app-modal-footer>